<div class="core-metrics card">
    <div class="core-metrics__header">
        <h2 class="core-metrics__title">{{ title }}</h2>
    </div>

    @if (hasError()) {
        <div class="core-metrics__error">
            <span class="core-metrics__error-text">Failed to load core metrics data</span>
        </div>
    } @else {
        <div class="core-metrics__grid">
            @if (isLoading()) {
                @for (skeleton of metricSkeletonItems; track skeleton) {
                    <div class="metric-card">
                        <div class="metric-card__icon">
                            <div class="skeleton skeleton-icon"></div>
                        </div>
                        <div class="metric-card__value">
                            <div class="skeleton skeleton-value"></div>
                        </div>
                        <div class="metric-card__label">
                            <div class="skeleton skeleton-label"></div>
                        </div>
                    </div>
                }
            } @else {
                @for (metric of metrics(); track metric.label) {
                    <div class="metric-card">
                        <button
                            class="metric-card__info"
                            [eiTooltip]="metric.tooltip"
                            eiTooltipPosition="top"
                            aria-label="Info"
                            type="button"
                        >
                            <img [src]="infoIcon" alt="" class="metric-card__info-icon" />
                        </button>
                        <div class="metric-card__icon">
                            <img [src]="metric.iconPath" alt="" class="metric-card__icon-img" />
                        </div>
                        <div
                            class="metric-card__value"
                            [class.metric-card__value--percent]="metric.isPercentage"
                            [class.metric-card__value--emphasis]="
                                metric.label === 'Conversion Rate' ||
                                metric.label === 'Drop-off Rate'
                            "
                            [class.metric-card__value--link]="isMetricClickable(metric)"
                        >
                            @if (isMetricClickable(metric)) {
                                <button
                                    z-button
                                    zType="link"
                                    type="button"
                                    class="metric-card__value-link"
                                    (click)="onMetricClick(metric)"
                                >
                                    {{ metric.value }}
                                </button>
                            } @else {
                                {{ metric.value }}
                            }
                        </div>
                        <div class="metric-card__label">
                            {{ metric.label }}
                        </div>
                    </div>
                }
            }
        </div>
    }
</div>
